import { styled } from '@lichtblick/styled';
import { Spacing } from '@lichtblick/theme';

export const ImageRow = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.Xs};
  justify-content: space-between;
  padding: 0.5rem;

  > span {
    max-width: 31.875rem;
  }
`;
